import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorks(companyId, regulationId, stageId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWorks,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
			},
		},
	)
}
function getRegulationsStagesPlanWorkPreview(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWorkPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorkPopup(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWorkPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorkExtendedPopup(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWorkExtendedPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}

function createRegulationsStagesPlanWork(companyId, regulationId, stageId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].createRegulationsStagesPlanWork, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWork(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWork, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
	})
}

function getRegulationsStagesPlanWorkDoneWorks(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].getRegulationsStagesPlanWorkDoneWorks, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
	})
}


function patchRegulationsStagesPlanWork(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].patchRegulationsStagesPlanWork, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWork(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].putRegulationsStagesPlanWork, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWork(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].deleteRegulationsStagesPlanWork, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorks,
	getRegulationsStagesPlanWorkPopup,
	getRegulationsStagesPlanWorkExtendedPopup,
	getRegulationsStagesPlanWorkPreview,
	getRegulationsStagesPlanWork,
	patchRegulationsStagesPlanWork,
	putRegulationsStagesPlanWork,
	createRegulationsStagesPlanWork,
	deleteRegulationsStagesPlanWork,
	getRegulationsStagesPlanWorkDoneWorks,
}
